import script from "./ZVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ZVideo.vue?vue&type=script&setup=true&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__